export default "__VITE_ASSET__jiDyawj1__"